import type { ResultOf } from '@graphql-typed-document-node/core'
import ReviewSummary from '~/components/reviews/ReviewSummary'
import type { RestaurantId } from '~/lib/graphql/scalars'
import { useIsPC } from '~/lib/ua'
import { sva } from '~/styled-system/css'
import type { RestaurantAreaReviewRankingFragment } from '../restaurantAreaReviewRanking.frag'
import type { RestaurantRating } from '../restaurantRating.frag'
import AreaReviewRanking from './AreaReviewRanking'

type Props = {
  rating: ResultOf<typeof RestaurantRating>['rating']
  areaReviewRanking?: ResultOf<typeof RestaurantAreaReviewRankingFragment> | null
  restaurantId: RestaurantId
  isReviewHidden: boolean
}

const styles = sva({
  slots: ['container', 'link'],
  base: {
    container: {
      marginX: '3',
      marginTop: '4',
      marginBottom: '0',
      spaceY: '2',
      borderBottom: 'light',
      pb: '3',
      _pc: {
        margin: '0',
        w: 'full',
        pb: '5',
      },
    },
    link: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      gap: '1',
    },
  },
})

export function GuideReviewSummary({
  rating,
  areaReviewRanking,
  restaurantId,
  isReviewHidden,
}: Props) {
  const isPC = useIsPC()
  const totalCount = rating?.totalCount
  const classes = styles()
  return (
    <div className={classes.container}>
      {areaReviewRanking && (
        <AreaReviewRanking areaReviewRanking={areaReviewRanking} rating={rating?.totalValue} />
      )}
      {!isReviewHidden && (
        <ReviewSummary
          restaurantId={restaurantId}
          totalCount={totalCount}
          totalValue={rating?.totalValue}
          size={isPC ? 'lg' : 'md'}
          linkClassName={classes.link}
        />
      )}
    </div>
  )
}
